import Scoreboard from './Scoreboard.vue';
export default Scoreboard;



// WEBPACK FOOTER //
// ./src/components/parts/scoreboard/index.js